import { Button } from '@zeiss/beyond-online-react';
import { openInNewTab } from '@zeiss/lib-helpers';
import { useTranslation } from 'react-i18next';

export const RequestCreationButton = () => {
  const { t } = useTranslation(['common']);

  const onClick = () =>
    openInNewTab(
      'https://zeissprod.service-now.com/it4u?id=cz_sc_create_ticket&sys_id=d111f0230f383e003ad21efae1050eda&link=IT4ULINK0000468',
    );

  return (
    <Button icon="ArrowRight" onClick={onClick} size="m" variant="primary">
      {t('common:action.requestANewX', {
        x: t('common:glossary.applicationList'),
      })}
    </Button>
  );
};
